import ReactQuill from 'react-quill';
import './quill.css';

let modules = {
    toolbar: false,
    clipboard: {
        matchVisual: false,
    },
};

const TextViewer = ({ className, value }) => {
    return (
        <div className={className}>
            <ReactQuill modules={modules} theme='snow' value={value} readOnly={true} />
        </div>
    );
};

export default TextViewer;
